import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { processResults } from 'services/search/utils';
import { SEARCH_TYPE } from 'services/search';

import { getTypeAndId, getRecordTitle } from 'utils/records';
import { parseQueryString, removeKeyFromQueryStringMultiple, updateQueryStringMultiple } from 'utils/url';
import { PAGES } from 'consts/pages';

import { RecordState } from './RecordProvider';

const useRecordFocus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const recordContext = useContext(RecordState);

  const params = parseQueryString(location.search);
  const recordName = params.r;
  const recordTimestamp = params.rts;
  const recordFocused = !!recordName;

  const focusRecord = (record) => {
    const nextRecordName = getRecordTitle(record);
    const [type] = getTypeAndId(nextRecordName);

    if (!recordContext[nextRecordName]) {
      const [processedRecord] = type === PAGES.investigator ? processResults(SEARCH_TYPE[type], [record]) : [record];

      recordContext.dispatch({
        type: 'FOCUS_RECORD',
        data: processedRecord,
        recordName: nextRecordName,
      });
    }

    const url = updateQueryStringMultiple({
      r: nextRecordName,
      alert: undefined,
      ...(type === PAGES.investigator ? { rts: record.ts } : {}),
    });

    const [pathname, query] = url.split('?');

    navigate(`${pathname}${query ? `?${query}` : ''}`, {
      state: {
        previousRecordName: recordName,
      },
    });
  };

  const focusGqlIndicator = (indicatorId, previousRecordName) => {
    const url = updateQueryStringMultiple({
      r: `IND-${indicatorId}`,
      alert: undefined,
    });

    const [pathname, query] = url.split('?');

    navigate(`${pathname}${query ? `?${query}` : ''}`, {
      state: {
        previousRecordName,
      },
    });
  };

  const unfocusRecord = () => {
    navigate(location.pathname + '?' + removeKeyFromQueryStringMultiple(['r', 'rts']));
  };

  const [recordType, recordId] = recordName ? getTypeAndId(recordName) : [];

  const record = recordName && recordContext[recordName];

  const hasPreviousRecord = !!location.state?.previousRecordName;

  return {
    recordFocused,
    recordName,
    recordTimestamp,
    recordType,
    recordId,
    unfocusRecord,
    focusRecord,
    record,
    hasPreviousRecord,
    focusGqlIndicator,
  };
};

export default useRecordFocus;
